import { render, staticRenderFns } from "./CreateStoreOwner.vue?vue&type=template&id=c844d10e&"
import script from "./CreateStoreOwner.vue?vue&type=script&lang=ts&"
export * from "./CreateStoreOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports